module.exports = __webpack_public_path__ + "static/media/TextToCheckInConfirmationScreen.9ad9829f.png";